var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "view-msg-dialog",
      attrs: {
        width: _vm.width,
        title: _vm.title,
        visible: _vm.dialogVisible,
        "split-line": "",
        scrollbar: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onClose,
        closed: _vm.onClosed,
      },
    },
    [
      _vm.data
        ? _c(
            "div",
            { staticClass: "view-msg-body", class: [_vm.data.Type] },
            [
              _vm.data.Type === "image"
                ? [
                    _c(
                      "el-image",
                      {
                        attrs: {
                          src: _vm.data.Url,
                          "preview-src-list": [_vm.data.Url],
                          "z-index": 9999,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: { slot: "placeholder" },
                            slot: "placeholder",
                          },
                          [
                            _vm._v(" Loading"),
                            _c("span", { staticClass: "dot" }, [_vm._v("...")]),
                          ]
                        ),
                      ]
                    ),
                  ]
                : _vm.data.Type === "video"
                ? [
                    _c("video", {
                      attrs: {
                        src: _vm.data.Url,
                        poster: _vm.data.Poster,
                        controlslist: "nodownload",
                        controls: "",
                      },
                    }),
                  ]
                : _vm.data.Type === "voice"
                ? [_c("VoicePlayer", { attrs: { src: _vm.data.Url } })]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }